import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif; // Ensure Poppins is loaded (e.g., via index.html or @import)
  }

  body {
    background: #f4f4f4; // Base background
    color: #333;
    line-height: 1.5; // Default line height
    -webkit-font-smoothing: antialiased; // Smoother fonts on WebKit
    -moz-osx-font-smoothing: grayscale; // Smoother fonts on Firefox
  }

  h1, h2, h3, h4, h5, h6 {
    color: #2c3e50; // Darker color for headings
    line-height: 1.3;
    margin-bottom: 0.75em; // Consistent bottom margin for headings
  }

  a {
    color: #f4a261; // Your brand color for links
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
        color: #e76f51; // Darker shade on hover
    }
  }

  img {
      max-width: 100%;
      height: auto;
      display: block; // Prevent bottom space under images
  }

  button {
      cursor: pointer;
      font-family: inherit; // Use the body font for buttons
  }
`;

export default GlobalStyle;